import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { KIUNGO_DOMAIN, LOGO_COMUNIDAD_TCEL, LOGO_COMUNIDAD_KIUNGO } from '../../app.service';
import { Location } from '@angular/common';

// Services
import { SidebarService } from '../../services/sidebar.service';
import { AuthenticationService } from '../../services/authentication.service';
import { CommunityService } from '../../services/community.service';

// Menu
declare var require: any;
const jsonMenu = require('../../../assets/menu/menu.json');

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass']
})
export class SidebarComponent implements OnInit {

  // variables
  public sidebarStatus = true;
  public subscriptionSidebar: Subscription;
  public subscriptionRoute: Subscription;
  public communityInSession: string;
  public codeCommunityInSession: string;
  public imageUser = null;
  public addressCommunity: string;
  public menu = null;
  public currentUser = null;
  public urlActive = null;
  public property = null;
  public realmUser = null;
  public logoCommunity = LOGO_COMUNIDAD_TCEL;

  constructor(
    private _sidebarService: SidebarService,
    private _route: ActivatedRoute,
    public router: Router,
    private location: Location,
    private _authenticationService: AuthenticationService,
    private _communityService: CommunityService
  ) {
    this._route.queryParams.subscribe(params => {
      if (params['realm']) {
        this.realmUser = params['realm'];
      }
    });

    // let realmUser = 'kastor';
    const angularRoute = this.location.path();
    const url = window.location.href;
    let domainAndApp = url.replace(angularRoute, '');
    domainAndApp = this._authenticationService.getDomain(domainAndApp);
    if (this.realmUser === 'kiungo' || domainAndApp === KIUNGO_DOMAIN) {
      this.logoCommunity = LOGO_COMUNIDAD_KIUNGO;
    }

    this._sidebarService.changeRoute(router.url);
  }

  ngOnInit() {
    this.initData();
    this.property = JSON.parse(localStorage.getItem('propertySesion')).name;
    this.router.events.subscribe((val: any) => {
      // see also
      if (val.url) {
        this._sidebarService.changeRoute(val.url);
      }
    });
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.communityInSession = localStorage.getItem('currentCommunity');

    if (this.currentUser.user_img) {
      this.imageUser = this.currentUser.user_img;
    } else {
      this.imageUser = '../../../assets/img/user2.png';
    }
    this.addressCommunity = localStorage.getItem('addressCommunity');

    this.menu = jsonMenu.menu;
    // oyente
    this.subscriptionSidebar = this._sidebarService.observableStateSidebar$
      .subscribe(
        () => {
          this.sidebarStatus = !this.sidebarStatus;
        });

    // oyente
    this.subscriptionRoute = this._sidebarService.observableRoute$
      .subscribe(
        res => {
          this.urlActive = res;
        });
  }

  // activamos y desactivamos sidebar
  public toggleClass(): void {
    this.sidebarStatus = !this.sidebarStatus;
  }

  initData() {
    this._communityService.getCommunityById(JSON.parse(localStorage.getItem('propertySesion')).communityId)
      .subscribe(response => {
        // this.communityInSession = response.community.name;
        this.codeCommunityInSession = response.community.id_number;
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/layout/sidebar/sidebar.component.ts